import { Component } from "@angular/core";

@Component({
    selector: "gmi-redirect",
    template: ""
})

export class RedirectComponent {
}
